import { render, staticRenderFns } from "./Configuratore.vue?vue&type=template&id=6581d114&"
import script from "./Configuratore.vue?vue&type=script&lang=js&"
export * from "./Configuratore.vue?vue&type=script&lang=js&"
import style0 from "./Configuratore.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports